export function filterFalsy<A>(arr: readonly A[] | undefined) {
  if (!arr) {
    return [];
  }
  return arr.filter(
    (item): item is Exclude<A, undefined | null | false | 0 | ""> =>
      Boolean(item)
  );
}
